<section 
  class="balsa-card" 
  aria-label="Card Container" 
  [class.centered]="centered" 
  [class]="responsiveClass | async"
  [style.margin-bottom]="marginBottom">
  <ng-content></ng-content>
</section>